// Weather
export const GET_WEATHER = 'GET_WEATHER';
// Air Quality
export const GET_AIR_QUALITY = 'GET_AIR_QUALITY';
// Tramits
export const IMPORT_TRAMITS = 'IMPORT_TRAMITS'; 
export const SEARCH_TRAMITS = 'SEARCH_TRAMITS';
// Header Info
export const GET_HEADER_INFO = 'GET_HEADER_INFO';